<template>
  <div v-show="!sharedState.editmode && selected.type === 'beacon'">
    <v-dialog v-model="dialog" scrollable persistent max-width="1250">
      <v-btn v-once icon slot="activator" @click="setItemAndMaxY">
        <v-icon>settings</v-icon>
      </v-btn>
      <v-card v-if="dialog">
        <v-card-title>
          <v-icon color="secondary">bluetooth</v-icon>
          <span>&ensp;</span>
          <span class="secondary--text">
            <strong>{{ item.name }}</strong>
          </span>
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <v-flex xs8 offset-xs2 mb-4 class="text-xs-center grey--text mapImage">
              <pointer :position="position" v-if="image" :current="true"></pointer>
              <pointer
                v-for="beacon in beaconsDisplay"
                :key="beacon.name"
                :position="{left: Math.floor(beacon.x * 800 / naturalImage.width) - 12, top: Math.floor(beacon.y * max.y / naturalImage.height) - 12}"
                :current="false"
              ></pointer>
              <img
                :src="image"
                :class="image ? 'dialog_image' : 'noimage dialog_image'"
                width="800"
                id="beacon_setting_image"
                alt
                @click="onClickMap"
                @load="onImageLoad"
                ref="beacon_setting_image"
              >
              <p v-if="!image">{{ $t('appstructure.no_image') }}</p>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs1 class="text-xs-right grey--text pt-2 pr-3">X</v-flex>
            <v-flex xs3>
              <v-text-field
                :value="Number(item.x)"
                suffix="pixel"
                type="number"
                :disabled="!image"
                class="pt-0"
                @input="changeX"
                @keydown="handleKeyDownX"
                :hint="`x should be between 0 and ${naturalImage.width}`"
                min="0"
                :max="naturalImage.width"
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="text-xs-right grey--text pt-2 pr-3">Y</v-flex>
            <v-flex xs3>
              <v-text-field
                :value="Number(item.y)"
                suffix="pixel"
                type="number"
                :disabled="!image"
                class="pt-0"
                @input="changeY"
                @keydown="handleKeyDownY"
                :hint="`y should be between 0 and ${naturalImage.height}`"
                min="0"
                :max="naturalImage.height"
              ></v-text-field>
            </v-flex>
            <v-flex xs1 class="text-xs-right grey--text pt-2 pr-3">{{ $t('appstructure.height') }}</v-flex>
            <v-flex xs3>
              <v-text-field
                v-model="item.height"
                suffix="cm"
                type="number"
                :disabled="!image"
                class="pt-0"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs1 class="text-xs-right grey--text pt-2 pr-3">{{ $t('appstructure.latitude') }}</v-flex>
            <v-flex xs3>
              <v-text-field v-model="item.latitude" type="number" class="pt-0"></v-text-field>
            </v-flex>
            <v-flex
              xs1
              class="text-xs-right grey--text pt-2 pr-3"
            >{{ $t('appstructure.longitude') }}</v-flex>
            <v-flex xs3>
              <v-text-field v-model="item.longitude" type="number" class="pt-0"></v-text-field>
            </v-flex>
            <v-flex
              xs1
              class="text-xs-right grey--text pt-2 pr-3"
            >{{ $t('appstructure.abs_height') }}</v-flex>
            <v-flex xs3>
              <v-text-field v-model="item.abs_height" suffix="m" type="number" class="pt-0"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="secondary" @click.stop="onClose">{{ $t('common.close') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="success" @click.stop="onSave">{{ $t('common.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Pointer from "../../pages/clusters/Pointer";
import PointerMethod from "../../utils/methods/PointerMethod";

export default {
  props: ["selected", "beaconsData", "onFilterBeacons", "image"],
  components: {
    Pointer
  },
  data() {
    return {
      dialog: false,
      map: "",
      naturalImage: {
        width: null,
        height: null,
      },
      default: {
        x: null,
        y: null,
        height: null,
        latitude: null,
        longitude: null,
        abs_height: null
      },
      item: {
        x: null,
        y: null,
        height: null,
        latitude: null,
        longitude: null,
        abs_height: null
      },
      max: {
        x: 800,
        y: 1000
      }
    };
  },
  watch: {
    dialog(val) {
      // action: triggers setY when dialog opens
      this.$nextTick(function() {
        val ? this.setItemAndMaxY() : null;
      });
    }
  },
  computed: {
    beaconsDisplay() {
      return this.onFilterBeacons(this.selected.id);
    },
  },
  methods: {
    compare(value, message, image_height) {
      return value < image_height || message;
    },
    setItemAndMaxY() {
      // On drag we receive a beacon item different than the ones already here (transformed in backend) with no (x,y)
      // if x,y we take the item as it is, otherwise we start with a default one
      this.item = { ...this.selected };
    },

    onImageLoad() {
      const img = this.$refs.beacon_setting_image;
      if (!img) return;

      this.max.y = img.clientHeight;
      this.setNaturalImage();

      this.onInitPoint();
    },

    setNaturalImage() {
     this.naturalImage.height = this.$refs.beacon_setting_image.naturalHeight;
     this.naturalImage.width = this.$refs.beacon_setting_image.naturalWidth;
    },

    handleKeyDownX(event) {
      const value = Number(event.target.value)
      const invertedValue = Number(value) * 800 / Number(this.naturalImage.width);

      if((invertedValue > this.max.x - 1) && event.keyCode !== 8 || event.keyCode == 189 || event.keyCode === 69) {
        event.preventDefault()
      }
    },

    handleKeyDownY(event) {
      const value = Number(event.target.value)
      const invertedValue = Number(value) * 1000 / Number(this.naturalImage.height);

      if((invertedValue > this.max.y - 1) && event.keyCode !== 8 || event.keyCode == 189 || event.keyCode === 69) {
        event.preventDefault()
      }
    },

    changeX(value) {
      this.item.x = Number(value) > this.naturalImage.width ? this.naturalImage.width : Number(value) < 0 ? 0 : Number(value);

      this.onInitPoint();
    },

    changeY(value) {
      this.item.y = Number(value) > this.naturalImage.height ? this.naturalImage.height : Number(value) < 0 ? 0 : Number(value);

      this.onInitPoint();
    },

    onClose() {
      this.item =  {
        x: null,
        y: null,
        height: null,
        latitude: null,
        longitude: null,
        abs_height: null
      };

      this.$emit("onClose");

      this.dialog = false;
    },

    onSave() {
      this.beaconsData.x = this.item.x;
      this.beaconsData.y = this.item.y;
      this.beaconsData.height = this.item.height;
      this.beaconsData.latitude = this.item.latitude;
      this.beaconsData.longitude = this.item.longitude;
      this.beaconsData.abs_height = this.item.abs_height;

      this.onClose();
    }
  },
  mixins: [PointerMethod],
  inject: ['sharedState']
};
</script>

<style scoped>
.mapImage {
  position: relative;
}
.dialog_image {
  display: block;
}
</style>
